/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import assets from './assets-provider';
import categories from './categories-provider';
import collections from './collections-provider';
import collectionsSort from './collectionsSort-provider';
import collectionThemes from './collectionThemes-provider';
import oneOffCredits from './oneOffCredits-provider';
import profile from './profile-provider';
import transactions from './transactions-provider';
import transfers from './transfers-provider';

const providers = {
  assets,
  collections,
  collectionsSort,
  themes: collectionThemes,
  categories,
  oneOffCredits,
  transactions,
  transfers,
  profile,
};

const dataProvider = {
  getList: async (resource, params) => {
    return providers[resource].getList(resource, params);
  },

  getTotalList: async (resource, params) => {
    return providers[resource].getTotalList(resource, params);
  },

  getOne: async (resource, params) => {
    return providers[resource].getOne(resource, params);
  },

  getMany: (resource, params) => providers[resource].getMany(resource, params),

  getManyReference: (resource, params) => Promise,

  create: (resource, params) => {
    return providers[resource].create(resource, params);
  },

  update: (resource, params) => {
    return providers[resource].update(resource, params);
  },

  updateMany: (resource, params) =>
    providers[resource].updateMany(resource, params),

  delete: (resource, params) => {
    return providers[resource].delete(resource, params);
  },

  deleteMany: (resource, params) => Promise,

  orderResource: (resource, params) => {
    return providers[resource].orderResource(resource, params);
  },
};

export default dataProvider;
